import {HomeDrawerItem} from "./HomeDrawerItem";
import {HomeContent} from "./HomeContent";
import {DrawerItemData} from "../../app/types";

export const HomeComponent: DrawerItemData = {
    uid: "home",
    drawerItem: HomeDrawerItem,
    content: HomeContent
};
